import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, storage, auth } from '../firebaseConfig';
import { doc, setDoc, Timestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { createUserWithEmailAndPassword } from 'firebase/auth';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoCloudUploadOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';

function RegistroProveedorExternoScreen() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Estados del formulario de Usuario
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Estados del formulario de Proveedor
    const [nombrePublico, setNombrePublico] = useState('');
    const [categoria, setCategoria] = useState('Mantenimiento');
    const [descripcion, setDescripcion] = useState('');
    const [costoVisita, setCostoVisita] = useState('');
    const [nombreContacto, setNombreContacto] = useState('');
    const [telefonoWhatsApp, setTelefonoWhatsApp] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [sitioWeb, setSitioWeb] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [redesSociales, setRedesSociales] = useState({
        facebook: '',
        instagram: '',
        twitter: '',
        tiktok: ''
    });

    // Ubicación Comercial
    const [calle, setCalle] = useState('');
    const [numeroExterior, setNumeroExterior] = useState('');
    const [colonia, setColonia] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [estado, setEstado] = useState('');

    // Documentos
    const [constanciaFiscal, setConstanciaFiscal] = useState(null);
    const [identificacionOficial, setIdentificacionOficial] = useState(null);

    const handleFileChange = (e, setFile) => {
        if (e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (password !== confirmPassword) {
            setError("Las contraseñas no coinciden.");
            setLoading(false);
            return;
        }

        if (!constanciaFiscal || !identificacionOficial) {
            setError("Debes subir ambos documentos obligatorios.");
            setLoading(false);
            window.scrollTo(0, 0);
            return;
        }

        if (!calle || !numeroExterior || !colonia || !codigoPostal || !ciudad || !estado) {
            setError("Debes completar todos los campos de la dirección de tu negocio.");
            setLoading(false);
            window.scrollTo(0, 0);
            return;
        }

        try {
            // 1. Crear usuario en Auth
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 2. Crear documento de usuario en Firestore
            await setDoc(doc(db, "usuarios", user.uid), {
                uid: user.uid,
                email: email,
                nombre: nombreContacto,
                rol: 'proveedor_externo',
                fechaRegistro: Timestamp.now()
            });

            // 3. Subir documentos a Storage
            const constanciaRef = ref(storage, `documentos_proveedores/${user.uid}/constancia_fiscal_${constanciaFiscal.name}`);
            const ineRef = ref(storage, `documentos_proveedores/${user.uid}/ine_${identificacionOficial.name}`);

            const [constanciaSnap, ineSnap] = await Promise.all([
                uploadBytes(constanciaRef, constanciaFiscal),
                uploadBytes(ineRef, identificacionOficial)
            ]);

            const constanciaUrl = await getDownloadURL(constanciaSnap.ref);
            const ineUrl = await getDownloadURL(ineSnap.ref);

            // 4. Crear perfil de proveedor
            await setDoc(doc(db, "market_proveedores", user.uid), {
                nombrePublico,
                categoria,
                descripcion,
                costoVisita: parseFloat(costoVisita),
                nombreContacto,
                telefonoWhatsApp,
                sitioWeb,
                redesSociales,
                ubicacion: {
                    tipo: 'local',
                    calle,
                    numeroExterior,
                    colonia,
                    codigoPostal,
                    ciudad,
                    estado
                },
                ratingPromedio: 0,
                totalCalificaciones: 0,
                documentos: {
                    constanciaFiscalUrl: constanciaUrl,
                    identificacionOficialUrl: ineUrl
                },
                estatus: "en_revision_superuser", // Estatus especial para externos
                fechaRegistro: Timestamp.now(),
                usuarioId: user.uid,
                esExterno: true
            });

            alert("¡Registro exitoso! Tu solicitud ha sido enviada al administrador general.");
            navigate('/login');

        } catch (err) {
            console.error("Error en registro:", err);
            setError("Error al registrar. " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-container" style={{ maxWidth: '800px' }}>
            <div className="form-header-container">
                <button onClick={() => navigate('/login')} className="form-back-button">
                    <IoArrowBack />
                </button>
                <h1 className="form-header">Registro de Proveedor Externo</h1>
            </div>

            <p style={{ marginBottom: '20px', color: '#666' }}>
                Únete a Kondo y ofrece tus servicios a múltiples condominios.
            </p>

            {error && <p className="form-mensaje error">{error}</p>}

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                {/* Sección Cuenta */}
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px' }}>1. Crea tu Cuenta</h3>
                <div className="form-group">
                    <label className="form-label">Correo Electrónico</label>
                    <input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Contraseña</label>
                        <input type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Confirmar Contraseña</label>
                        <input type="password" className="form-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                    </div>
                </div>

                {/* Sección Negocio */}
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginTop: '20px' }}>2. Datos del Negocio</h3>
                <div className="form-group">
                    <label className="form-label">Nombre Comercial del Negocio</label>
                    <input type="text" className="form-input" value={nombrePublico} onChange={(e) => setNombrePublico(e.target.value)} required />
                </div>

                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Categoría</label>
                        <select className="form-select" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                            <option value="Mantenimiento">Mantenimiento</option>
                            <option value="Limpieza">Limpieza</option>
                            <option value="Jardinería">Jardinería</option>
                            <option value="Seguridad">Seguridad</option>
                            <option value="Plomería">Plomería</option>
                            <option value="Electricidad">Electricidad</option>
                            <option value="Cerrajería">Cerrajería</option>
                            <option value="Carpintería">Carpintería</option>
                            <option value="Pintura">Pintura</option>
                            <option value="Albañilería">Albañilería</option>
                            <option value="Fumigación">Fumigación</option>
                            <option value="Mudanzas">Mudanzas</option>
                            <option value="Internet/TV">Internet/TV</option>
                            <option value="Gas">Gas</option>
                            <option value="Agua">Agua</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Costo Base de Visita ($)</label>
                        <input type="number" className="form-input" value={costoVisita} onChange={(e) => setCostoVisita(e.target.value)} required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">Descripción de Servicios</label>
                    <textarea className="form-textarea" rows="3" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} required />
                </div>

                {/* Sección Ubicación */}
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginTop: '20px' }}>3. Ubicación Comercial Obligatoria</h3>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 2 }}>
                        <label className="form-label">Calle</label>
                        <input type="text" className="form-input" value={calle} onChange={(e) => setCalle(e.target.value)} placeholder="Ej. Av. de los Insurgentes" required />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Número Ext/Int</label>
                        <input type="text" className="form-input" value={numeroExterior} onChange={(e) => setNumeroExterior(e.target.value)} placeholder="Ej. 1234, Int. A" required />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Colonia</label>
                        <input type="text" className="form-input" value={colonia} onChange={(e) => setColonia(e.target.value)} required />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Código Postal</label>
                        <input type="text" className="form-input" value={codigoPostal} onChange={(e) => setCodigoPostal(e.target.value)} required />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Ciudad / Municipio</label>
                        <input type="text" className="form-input" value={ciudad} onChange={(e) => setCiudad(e.target.value)} required />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Estado</label>
                        <input type="text" className="form-input" value={estado} onChange={(e) => setEstado(e.target.value)} required />
                    </div>
                </div>

                {/* Sección Contacto */}
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginTop: '20px' }}>4. Contacto y Redes</h3>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Nombre del Contacto</label>
                        <input type="text" className="form-input" value={nombreContacto} onChange={(e) => setNombreContacto(e.target.value)} required />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label className="form-label">Teléfono WhatsApp</label>
                        <input type="tel" className="form-input" value={telefonoWhatsApp} onChange={(e) => setTelefonoWhatsApp(e.target.value)} required />
                    </div>
                </div>

                {/* Sección Documentos */}
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginTop: '20px' }}>5. Documentación Obligatoria</h3>
                <div className="form-group">
                    <label className="form-label">Constancia de Situación Fiscal (PDF/Imagen)</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input type="file" accept=".pdf,image/*" onChange={(e) => handleFileChange(e, setConstanciaFiscal)} required />
                        {constanciaFiscal && <IoCheckmarkCircleOutline color="green" size={24} />}
                    </div>
                </div>
                <div className="form-group">
                    <label className="form-label">Identificación Oficial (INE/Pasaporte)</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input type="file" accept=".pdf,image/*" onChange={(e) => handleFileChange(e, setIdentificacionOficial)} required />
                        {identificacionOficial && <IoCheckmarkCircleOutline color="green" size={24} />}
                    </div>
                </div>

                <button type="submit" className="form-button" disabled={loading} style={{ marginTop: '20px' }}>
                    {loading ? 'Enviando Solicitud...' : 'Registrarse y Enviar Solicitud'}
                </button>

            </form>
        </div>
    );
}

export default RegistroProveedorExternoScreen;
